// Table import
import { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import React from "react";
import { useAlert } from "react-alert";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory from "react-bootstrap-table2-filter";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { API_URL } from "../../Constents";
import ModalEmpoyeeDetails from "../Modals/ModalEmployeeDetails";
import ReverseDateString from "../Hooks/ReverseDateString";

import { BsBoxArrowUpRight } from "react-icons/bs";
import LoadingGifs from "../../images/YAAMS-gif.gif";

const AutoDetectionLeave = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [leaveName, setLeaveName] = useState();
  const [err, setErr] = useState();
  const [employeeId, setemployeeId] = useState();
  const [leaveId, setLeaveId] = useState();
  const [show, setShow] = useState(false);
  const [showEmp, setShowEmp] = useState(false);
  const [getStatus, setGetStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [approvalComments, setApprovalComments] = useState("");
  const [approveStatus, setApproveStatus] = useState(null);
  const [leaveExportStatusMsg, setLeaveExportStatusMsg] = useState("");

  const handleCloseEmp = () => setShowEmp(false);
  const handleShowEmp = () => setShowEmp(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalID, setModalId] = useState("");
  const alert = useAlert();
  const fetchLeaveData = async () => {
    const url = API_URL + `/fetch-deduct-leaves/?search=${searchText}`;
    const userData = JSON.parse(window.sessionStorage.getItem("user"));
    const bodyContent = JSON.stringify({
      from_date: startDate,
      to_date: endDate,
      leave_type: getStatus,
    });
    const headerlist = {
      Authorization: "Token " + userData.seucrity_token,
      "Content-Type": "application/json",
    };
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: headerlist,
        body: bodyContent,
      });
      const data = await res.json();
      setLeaveData(data?.data);
    } catch (err) {
      setErr(err);
      alert.error("Internal Server Error");
    }
  };

  const leaveActionHandler = async (leaveStatus) => {
    const url =
      API_URL +
      "/approve-leave/?leave_id=" +
      leaveId +
      "&" +
      "user_id=" +
      employeeId;

    console.log(url);
    const bodyContent = JSON.stringify({
      status: leaveStatus,
      approval_comment: approvalComments,
    });
    const userData = JSON.parse(window.sessionStorage.getItem("user"));
    const headersList = {
      Authorization: "Token " + userData.seucrity_token,
      "Content-Type": "application/json",
    };

    try {
      const res = await fetch(url, {
        method: "PATCH",
        body: bodyContent,
        headers: headersList,
      });
      const data = await res.json();
      console.log(data);
      setApproveStatus(data);
      //props.setReload(data);
      handleClose();
    } catch (err) {
      console.log(err);
      alert.error("Internal Server Error");
    }
  };

  useEffect(() => {
    fetchLeaveData();
  }, [getStatus, startDate, endDate, searchText]);

  if (!leaveData)
    return (
      <div className="loadingGif">
        <img src={LoadingGifs} alt="Loading Gif" />
      </div>
    );
  if (err) return <h1>Some error occured</h1>;


  const columns = [
    { dataField: "employee", text: "Employee ID", sort: true },

    {
      dataField: "employee_name",
      text: "Employee Name",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <div className="row align-items-center">
              <Button
                variant="link"
                style={{
                  color: "#3E3E3E",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  textAlign: "left",
                }}
                onClick={() => {
                  console.log(row.id);
                  setModalId(row.employee);
                  handleShowEmp();
                }}
              >
                <span>
                  {row.employee_name}
                  <BsBoxArrowUpRight
                    style={{
                      fontSize: "10px",
                      marginLeft: "2px",
                      // marginBottom: "10px",
                      color: "#3E3E3E",
                      fontWeight: "600",
                    }}
                  />
                </span>
              </Button>
            </div>
          </>
        );
      },
    },
   
    { dataField: "leave_type", text: "Leave Type", sort: true },
    { dataField: "organization", text: "Organization", sort: true },
    {
      dataField: "from_date",
      text: "from",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return ReverseDateString(row.from_date);
      },
    },
    {
      dataField: "to_date",
      text: "to",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return ReverseDateString(row.to_date);
      },
    },
   
    { dataField: "quantity", text: "Quantity", sort: true },
    { dataField: "remaining_leave", text: "Remaining", sort: true }, //filter: textFilter() },
  
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    lastPageText: "End",
    firstPageText: "First",
    nextPageText: "Next",
    prePageText: "Previous",
    showTotal: true,
    alwaysShowAllBtns: true,
  });

  return (
    <div className="maincontent">
      <div className="highlight all_form_spacing">
        {approveStatus &&
        approveStatus.status === true &&
        approveStatus.status !== undefined ? (
          <div className="alert alert-success" role="alert">
            {approveStatus.message}
          </div>
        ) : approveStatus &&
          approveStatus.status === false &&
          approveStatus.status !== undefined ? (
          <div className="alert alert-danger" role="alert">
            {approveStatus.message}
          </div>
        ) : (
          ""
        )}
        <h1 className="mx-2" style={{ color: "#DD3944" }}>
          Auto Deducted Leaves
        </h1>
        <ToolkitProvider
          keyField="id"
          bootstrap4
          data={leaveData}
          columns={columns}
          ignoreHeader
          exportCSV={{
            fileName: "Leave.csv",
          }}
          search
        >
          {(props) => (
            <React.Fragment>
              <div className="container">
                <div className="row">
                  <div className="col-md-3 mt-4">
                    <div className="position-relative newsearch_box">
                      {/* <SearchBar
                        className="newSearchWrapper"
                        placeholder="Search Name"
                        srText=""
                        {...props.searchProps}
                      />
                      <BiSearch /> */}

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Name"
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="dob">Start Date</label>
                    <input
                      className="form-select form-control "
                      type="date"
                      id="StartDate"
                      name="StartDate"
                      value={startDate}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="dob">End Date</label>
                    <input
                      className="form-select form-control"
                      type="date"
                      id="birthday"
                      name="birthday"
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="designition">Select Leaves Type</label>
                    <select
                      className="form-select form-control"
                      id="inputGroupSelect02"
                      onChange={(e) => {
                        setGetStatus(e.target.value);
                      }}
                    >
                      <option value="Privilege Leave">Privilege Leave</option>
                      <option value="Casual Leave">Casual Leave</option>
                      <option value="Loss of Pay">Loss of Pay</option>
                      <option value="">All</option>
                    </select>
                  </div>
                </div>

                {leaveExportStatusMsg === "" ? (
                  ""
                ) : (
                  <p className="msg_fail">{leaveExportStatusMsg}</p>
                )}
                <BootstrapTable
                  pagination={pagination}
                  filter={filterFactory()}
                  {...props.baseProps}
                  bordered={false}
                  noDataIndication={() => {
                    return <h3>No data available for this filter</h3>;
                  }}
                  condensed
                />
              </div>
            </React.Fragment>
          )}
        </ToolkitProvider>
        <Modal size="xl" show={showEmp} onHide={handleCloseEmp}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <ModalEmpoyeeDetails id={modalID} />
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            {/* <Modal.Title>Leave Approve </Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center mb-3">
              <h2>
                Take Action on <i>{leaveName}</i>'s Leave
              </h2>
            </div>
            <div className="d-flex justify-content-center mb-3">
              <textarea
                type="text"
                className="form-control"
                placeholder="Approval/Rejection Comments (if Any)"
                style={{ width: "400px" }}
                onChange={(e) => setApprovalComments(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-center mb-3">
              <button
                className="btn btn-success btn-lg me-3"
                onClick={() => leaveActionHandler("approved")}
              >
                Approve
              </button>
              <button
                className="btn btn-danger btn-lg"
                onClick={() => leaveActionHandler("rejected")}
              >
                Reject
              </button>
            </div>
          </Modal.Body>
          {/* <Modal.Footer></Modal.Footer> */}
        </Modal>
      </div>
    </div>
  );
};

export default AutoDetectionLeave;
